import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-businesspropertystatement',
    templateUrl: './businesspropertystatement.component.html',
    styleUrls: ['./businesspropertystatement.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinesspropertystatementComponent implements OnInit, AfterViewInit {

  id: number;
  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }

  ngAfterViewInit() {
    console.log(this.id);
  }
  ngOnInit() {
  }

}
